import ERouter  from './q_componts/e_router.vue'

import genApi, { get } from "@/quick/gen-api";
export default{
  components:{ ERouter },
  props:['autoConfig','edit'],
  data(vm){
    return {
      context:vm,
      ruleForm: {
        // be_time: {
        //   begin_date: "",
        //   end_date: ""
        // },
      },
      rules: {
        // "be_time.begin_date": [
        //   {
        //     required: true,
        //     message: "请选择起始时间",
        //     trigger: "change"
        //   }
        // ],
        // "be_time.end_date": [
        //   {
        //     required: true,
        //     message: "请选择结束时间",
        //     trigger: "change"
        //   }
        // ]
      },
    }
  },
  watch:{
    edit(nv){
      if(nv==false ){
        const  { saveFormApi, updateFormApi } = genApi(this.autoConfig.postApi) ;
        this.saveFormApi = saveFormApi
        this.updateFormApi = updateFormApi
      }
    },
  }
  ,
  mounted(){
    // this.context = this
  },
  methods:{
    
  }


}